export const adminTranslations = {
  ru: {
    'admin.workers.title': 'Workers',
    'admin.workers.subtitle': 'Read-only обзор фоновых задач. Ручной запуск доступен только для безопасных read/sync и file cleanup операций.',
    'admin.workers.loading': 'Загружаем статусы workers…',
    'admin.workers.loadError': 'Не удалось загрузить worker dashboard.',
    'admin.workers.manualRun': 'manual run',
    'admin.workers.column.worker': 'Worker',
    'admin.workers.column.category': 'Категория',
    'admin.workers.column.state': 'Состояние',
    'admin.workers.column.interval': 'Interval',
    'admin.workers.column.lastRun': 'Последний запуск',
    'admin.workers.column.queues': 'Очереди',
    'admin.workers.column.manualRun': 'Manual run',
    'admin.workers.state.dangerous': 'опасный',
    'admin.workers.state.enabled': 'включён',
    'admin.workers.state.disabled': 'выключен',
    'admin.workers.errorAt': 'ошибка: {date}',
    'admin.workers.run': 'Запустить',
    'admin.workers.unavailable': 'Недоступно',
    'admin.workers.category.read_sync': 'read/sync',
    'admin.workers.category.reconciliation': 'reconciliation',
    'admin.workers.category.file_cleanup': 'file cleanup',
    'admin.workers.category.payment_posting': 'payment posting',
    'admin.workers.category.hard_delete': 'hard delete',
    'admin.workers.category.notification_escalation': 'notification SLA',
    'admin.workers.category.outbox': 'outbox',
  },
  en: {
    'admin.workers.title': 'Workers',
    'admin.workers.subtitle': 'Read-only overview of background jobs. Manual run is available only for safe read/sync and file cleanup operations.',
    'admin.workers.loading': 'Loading worker statuses…',
    'admin.workers.loadError': 'Failed to load worker dashboard.',
    'admin.workers.manualRun': 'manual run',
    'admin.workers.column.worker': 'Worker',
    'admin.workers.column.category': 'Category',
    'admin.workers.column.state': 'State',
    'admin.workers.column.interval': 'Interval',
    'admin.workers.column.lastRun': 'Last run',
    'admin.workers.column.queues': 'Queues',
    'admin.workers.column.manualRun': 'Manual run',
    'admin.workers.state.dangerous': 'dangerous',
    'admin.workers.state.enabled': 'enabled',
    'admin.workers.state.disabled': 'disabled',
    'admin.workers.errorAt': 'error: {date}',
    'admin.workers.run': 'Run',
    'admin.workers.unavailable': 'Unavailable',
    'admin.workers.category.read_sync': 'read/sync',
    'admin.workers.category.reconciliation': 'reconciliation',
    'admin.workers.category.file_cleanup': 'file cleanup',
    'admin.workers.category.payment_posting': 'payment posting',
    'admin.workers.category.hard_delete': 'hard delete',
    'admin.workers.category.notification_escalation': 'notification SLA',
    'admin.workers.category.outbox': 'outbox',
  },
  id: {
    'admin.workers.title': 'Workers',
    'admin.workers.subtitle': 'Ringkasan read-only pekerjaan latar belakang. Manual run hanya untuk operasi read/sync dan file cleanup yang aman.',
    'admin.workers.loading': 'Memuat status workers…',
    'admin.workers.loadError': 'Gagal memuat worker dashboard.',
    'admin.workers.manualRun': 'manual run',
    'admin.workers.column.worker': 'Worker',
    'admin.workers.column.category': 'Kategori',
    'admin.workers.column.state': 'Status',
    'admin.workers.column.interval': 'Interval',
    'admin.workers.column.lastRun': 'Run terakhir',
    'admin.workers.column.queues': 'Antrean',
    'admin.workers.column.manualRun': 'Manual run',
    'admin.workers.state.dangerous': 'berbahaya',
    'admin.workers.state.enabled': 'aktif',
    'admin.workers.state.disabled': 'nonaktif',
    'admin.workers.errorAt': 'error: {date}',
    'admin.workers.run': 'Jalankan',
    'admin.workers.unavailable': 'Tidak tersedia',
    'admin.workers.category.read_sync': 'read/sync',
    'admin.workers.category.reconciliation': 'reconciliation',
    'admin.workers.category.file_cleanup': 'file cleanup',
    'admin.workers.category.payment_posting': 'payment posting',
    'admin.workers.category.hard_delete': 'hard delete',
    'admin.workers.category.notification_escalation': 'notification SLA',
    'admin.workers.category.outbox': 'outbox',
  },
} as const;
